import React from "react";

const PitchTrackerContext = React.createContext(null);

export default PitchTrackerContext;
